import React from 'react';
import logoImg from '../assets/privilege-logo.png';

/**
 * Privilege Valet Parking brand logo.
 * Gold artwork on a transparent background (PNG) so it blends cleanly
 * over any surface. Pass a Tailwind height class via `className`.
 */
const Logo = ({ className = 'h-12', alt = 'Privilege Valet Parking Madrid' }) => (
  <img
    src={logoImg}
    alt={alt}
    className={`w-auto object-contain select-none ${className}`}
    draggable={false}
  />
);

export default Logo;
